import {
  type BigFraction,
  bigFractionFromNumber,
} from "@aprao/common/src/math/BigFraction.js";

export const FRACTION_ZERO = bigFractionFromNumber(0);
export const FRACTION_ONE = bigFractionFromNumber(1);
export const FRACTION_TWO = bigFractionFromNumber(2);
export const FRACTION_TWELVE = bigFractionFromNumber(12);
export const FRACTION_100 = bigFractionFromNumber(100);

/**
 * Checks if value is less than or equal to other.
 *
 * @param value the value to compare
 * @param other the other value to compare
 *
 * @returns `true` if value is less than or equal to other, else `false`
 */
export const fractionLte = (value: BigFraction, other: BigFraction) =>
  value.compare(other) <= 0;

export const fractionLt = (value: BigFraction, other: BigFraction) =>
  value.compare(other) < 0;

export const fractionMin = (
  value: BigFraction,
  ...values: ReadonlyArray<BigFraction>
) =>
  [value, ...values].reduce(
    (min, curr) => (0 < min.compare(curr) ? curr : min),
    value,
  );

export const fractionMax = (
  value: BigFraction,
  ...values: ReadonlyArray<BigFraction>
) =>
  [value, ...values].reduce(
    (max, curr) => (max.compare(curr) < 0 ? curr : max),
    value,
  );

export const fractionClamp = (
  min: BigFraction | null,
  value: BigFraction,
  max: BigFraction | null,
) => {
  const lowerBound = fractionMax(value, min ?? value);
  return fractionMin(lowerBound, max ?? lowerBound);
};

export const fractionSum = (values: Iterable<BigFraction>) => {
  let total = FRACTION_ZERO;
  for (const value of values) {
    total = total.add(value);
  }
  return total;
};
